module.exports = __webpack_public_path__ + "static/media/home-compactors.cd62bb93.jpg";